import { loadLanguageAsync } from "../services/i18n-setup";
import Vue from 'vue'

const processLanguageParameter = (languages, routeLang = 'nl-be', translations = []) => {
    if (routeLang && languages.some(l => l.code === routeLang)) {
        /* languages contains the language we're looking for */
        loadLanguageAsync(routeLang, translations)
    } else if (routeLang && languages.some(l => l.code.substring(0,2) === routeLang.substring(0,2))) {
        /* languages contains the language we're looking for */
        var language = languages.find(l => l.code.substring(0,2) === routeLang.substring(0,2))
        loadLanguageAsync(language.code, translations)
    } else if (!routeLang && Vue.ls.get('language')) {
        loadLanguageAsync(Vue.ls.get('language'), translations)
    }
}

export default processLanguageParameter


// WEBPACK FOOTER //
// ./src/helpers/languageProcessor.js